import { render, staticRenderFns } from "./PageSelector.vue?vue&type=template&id=751d7eec&scoped=true"
import script from "./PageSelector.vue?vue&type=script&lang=js"
export * from "./PageSelector.vue?vue&type=script&lang=js"
import style0 from "./PageSelector.vue?vue&type=style&index=0&id=751d7eec&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "751d7eec",
  null
  
)

export default component.exports